export default import.meta.ROLLUP_FILE_URL_7WGWBYiphQhhYc3TxAyZDQ